module.exports = __webpack_public_path__ + "img/background001.37c296fa.jpg";